import Checkbox from "lib/formInputs/checkbox/Checkbox";
import DatePicker from "lib/formInputs/datepicker/Datepicker";
import Select from "lib/formInputs/select/Select";
import React from "react";

import { propTypes } from "lib/formInputs/config";

import FormInputGroup from "./formInputGroups/FormInputGroup";

/**
 * Create form input elements as per the props configuration
 * @param {*} props
 * @return {JSX.Element}
 */
export default function FormInput(props) {
  const {
    // common input props
    type,
    id,
    label,
    className,
    name,
    disabled,
    placeholder,
    formik,
    value,
    defaultValue,

    // Radio / Checkbox props
    checked,
    onChange,

    // Select / Dropdown props
    isClearable,
    isDisabled,
    isLoading,
    isSearchable,
    isMulti,
    creatable,
    options,

    // Date Props
    selected,
  } = props;

  switch (type) {
    case "text":
    case "email":
    case "password":
      return (
        <FormInputGroup
          type={type}
          id={id}
          label={label}
          className={className}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          formik={formik}
          defaultValue={defaultValue}
        />
      );
    case "checkbox":
    case "radio":
      return (
        <Checkbox
          type={type}
          id={id}
          label={label}
          className={className}
          name={name}
          disabled={disabled}
          placeholder={placeholder}
          checked={checked}
          formik={formik}
          value={value}
          onChange={onChange}
        />
      );
    case "select":
      return (
        <Select
          id={id}
          label={label}
          placeholder={placeholder}
          className={className}
          name={name}
          isClearable={isClearable}
          isDisabled={isDisabled}
          isLoading={isLoading}
          isSearchable={isSearchable}
          isMulti={isMulti}
          creatable={creatable}
          options={options}
          formik={formik}
        />
      );
    case "date":
      return <DatePicker selected={selected} formik={formik} name={name} />;

    default:
      return null;
  }
}

FormInput.propTypes = propTypes;
